// import { directive as vClickOutside } from "vue-clickaway";
import { sanitizeHtml } from "@/helpers/sanitizeHtml";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

/**
 * `v-safe-html="html"`: v-html that always sanitizes. Use it instead of bare v-html for anything
 * built from server data, so a binding is safe by default rather than by its data source.
 */
function setSafeHtml(el, { value, oldValue }) {
  // Compare first: reading innerHTML serializes the whole subtree on every parent re-render.
  if (value === oldValue && el.hasChildNodes()) return;
  el.innerHTML = sanitizeHtml(value == null ? "" : String(value));
}

const GlobalDirectives = {
  install(Vue) {
    Vue.directive("safe-html", {
      beforeMount: setSafeHtml,
      updated: setSafeHtml,
    });

    Vue.directive("click-outside", {
      beforeMount: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          // here I check that click was outside the el and his childrens
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unmounted: function(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      }
    });
  }
};

export default GlobalDirectives;
